import { ZButton } from "@/shared/components/button";
import { 
  ZModal, 
  ZModalBody, 
  ZModalContent 
} from "@/shared/components/modal";
import { Button, Spinner } from "@nextui-org/react";
import { Loader2, X } from "lucide-react";

interface DiscardAgentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDiscard: () => void;
  isDiscarding?: boolean; // Add loading state prop
}

export default function DiscardAgentModal({
  isOpen,
  onClose,
  onDiscard,
  isDiscarding = false
}: DiscardAgentModalProps) {
  return (
    <ZModal 
      isOpen={isOpen} 
      onOpenChange={onClose}
      hideCloseButton
      classNames={{
        base: "w-[458px] h-[168px] shadow-[0px_0px_24px_rgba(0,0,0,0.05)] rounded-2xl"
      }}
    >
      <ZModalContent className="relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 w-4 h-4 text-[#71717A] hover:text-gray-900 z-10"
        >
          <X className="w-4 h-4" />
        </button>

        <ZModalBody className="p-6">
          <div className="flex flex-col items-center gap-6">
            {/* Content Container */}
            <div className="flex flex-col items-center gap-2 w-full">
              {/* Title */}
              <h3 className="text-[18px] font-semibold leading-7 text-center text-[#11181C] w-full">
                Discard Agent Creation?
              </h3>
              
              {/* Description */}
              <p className="text-sm font-normal leading-5 text-center text-[#777780] w-full">
                All your progress on creating this agent will be lost.
              </p>
            </div>

            {/* Buttons */}
            <div className="flex flex-row items-start gap-4 w-full">
              <ZButton
                variant="bordered"
                onClick={onClose}
                className="flex-1 h-10 px-4 py-2 bg-white border border-[#006FEE] rounded-md text-[#006FEE] text-base font-medium leading-6"
                disabled={isDiscarding}
              >
                Cancel
              </ZButton>
              
              <Button
                onClick={onDiscard}
                className="flex-1 h-10 px-4 py-2 bg-[#F4286F] rounded-md text-white text-base font-medium leading-6 hover:bg-[#E0235F]"
                isDisabled={isDiscarding}
                isLoading={isDiscarding}
              >
                Yes, Discard 
              </Button>
            </div>
          </div>
        </ZModalBody>
      </ZModalContent>
    </ZModal>
  );
}